import * as passengerTypes from 'state/checkoutPage/travelers/constants/passengerTypes';
import { setSelectedFlightsExtras } from '../actions';

export default function setSelectedFlightsExtrasInitialValue(reset) {
  return (dispatch, getState) => {
    const { selectedFlightsExtras } = getState().checkoutPageTravelSummary;

    if (!selectedFlightsExtras || reset) {
      const selectedFlightsExtras = {
        [passengerTypes.ADULT]: {},
        [passengerTypes.CHILD]: {},
        [passengerTypes.INFANT]: {},
        [passengerTypes.GROUP]: [],
      };

      dispatch(setSelectedFlightsExtras(selectedFlightsExtras));
    }
  };
}
